export default __webpack_public_path__ + "static/object-larger-do-ea5ba5a4141d04d0c7578c5ca77c1ff419589218ab4c85f380e6d3cd5b594eac.png";